// extracted by mini-css-extract-plugin
export var articleLink = "br10-sb";
export var articleWrap = "br10-tb";
export var avatar = "br10-yb";
export var avatarImg = "br10-zb";
export var content = "br10-ub";
export var des = "br10-vb";
export var img = "br10-Bb";
export var imgWrap = "br10-Ab";
export var subtitle = "br10-xb";
export var title = "br10-wb";